import { VALIDATION_DDD, VALIDATION_DDD_MSG_EMPTY, VALIDATION_DDD_MSG_INVALID } from './constants'

export default function validateDDD(value) {
  const validate = !VALIDATION_DDD.test(value) ? VALIDATION_DDD_MSG_INVALID : undefined
  return !value ? VALIDATION_DDD_MSG_EMPTY : validate
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/dddValidate.js